import { Action } from "../../../types/state/action";
import { IMasterArtworkRequestHistory, MasterArtworkCollectionState } from "../collections/data.type";
import { MasterArtworkNameState } from "../artwork-name/data.type";
import { IColor, IDecorationTech, IMold, IRequestStatusReason } from "../../../types/data.interface";
import { MasterArtworkNumberState } from "../artwork-number/data.type";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

export type MasterArtworkPrintingTechniqueState = {

  id?: string;
  name: string;
  code?: string;
  decoration_technique: ValueOrNull<IDecorationTech>;
  color:  ValueOrNull<IColor>;
  technical_file_url: string;
  comments_and_technical_file_requests: string;

  image_url: string;
  region: string;


  requestId: string;
  requestStatus: ValueOrNull<string>;
  requestDateFrom: string;
  requestDateTo: string;
  requestor: string;

  requestHistory: IMasterArtworkRequestHistory;

  status?: string;
  comment?: string;

  collection: ValueOrNull<MasterArtworkCollectionState>;
  artwork_name: ValueOrNull<MasterArtworkNameState>;
  artwork_number: ValueOrNull<MasterArtworkNumberState>;
  molds: ValueOrNull<IMold[]>;

  submitComment: string;
  approveComment: string;
  rejectComment: string;
  rejectReason: IRequestStatusReason | null;

  hasUnsavedChanges: boolean;
  isValid: ValueOrNull<boolean>;
  isReadOnly:boolean;
  purchasedPartOrSubAssembly:ValueOrNull<Option<string>> | string


}

export enum MasterArtworkPrintingTechniqueActionTypes {

  SET_PRINTING_TECHNIQUE ="masterArtworkPrintingTechnique/setPrintingTechnique",
  RESET_STATE ="masterArtworkPrintingTechnique/resetState",
  SET_COLLECTION= "masterArtworkPrintingTechnique/setCollection",
  SET_ID= "masterArtworkPrintingTechnique/setId",
  SET_NAME= "masterArtworkPrintingTechnique/setName",
  SET_DECORATION_TECHNIQUE= "masterArtworkPrintingTechnique/setDecorationTechnique",
  SET_COLOR= "masterArtworkPrintingTechnique/setColor",
  SET_TECHNICAL_FILE_URL= "masterArtworkPrintingTechnique/setTechnicalFileUrl",
  SET_COMMENTS_AND_TECHNICAL_FILE_REQUESTS= "masterArtworkPrintingTechnique/setCommentsAndTechnicalFileRequests",
  SET_CODE= "masterArtworkPrintingTechnique/setCode",
  SET_IMAGE_URL= "masterArtworkPrintingTechnique/setImageUrl",
  SET_REGION= "masterArtworkPrintingTechnique/setRegion",
  SET_ARTWORK_NAME= "masterArtworkPrintingTechnique/setArtworkName",
  SET_ARTWORK_NUMBER= "masterArtworkPrintingTechnique/setArtworkNumber",
  SET_MOLDS= "masterArtworkPrintingTechnique/setMolds",
  SET_REQUEST_ID= "masterArtworkPrintingTechnique/setRequestId",
  SET_REQUEST_STATUS= "masterArtworkPrintingTechnique/setRequestStatus",
  SET_REQUEST_DATE_FROM= "masterArtworkPrintingTechnique/setRequestDateFrom",
  SET_REQUEST_DATE_TO= "masterArtworkPrintingTechnique/setRequestDateTo",
  SET_REQUESTOR= "masterArtworkPrintingTechnique/setRequestor",
  SET_STATUS= "masterArtworkPrintingTechnique/setStatus",
  SET_SUBMIT_COMMENT = "masterArtworkPrintingTechnique/setSubmitComment",

  SET_APPROVE_COMMENT = "masterArtworkPrintingTechnique/setApproveComment",
  SET_REJECT_COMMENT = "masterArtworkPrintingTechnique/setRejectComment",
  SET_REJECT_REASON = "masterArtworkPrintingTechnique/setRejectReason",
  SET_IS_VALID = "masterArtworkPrintingTechnique/setIsValid",
  SET_IS_READ_ONLY = "masterArtworkPrintingTechnique/setIsReadOnly",
  SET_UNSAVED_CHANGES = "masterArtworkPrintingTechnique/setUnsavedChanges",
  SET_PURCHASED_PART_OR_SUB_ASSEMBLY = "masterArtworkPrintingTechnique/stPurchasedPartOrSubAssembly",
}

export type MasterArtworkPrintingTechniqueActionType = Action<
  MasterArtworkPrintingTechniqueActionTypes,
  Partial<MasterArtworkPrintingTechniqueState>
>;